import { AgencyTaskSchema } from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postsKeys } from '@/queries/posts/keys';
import { apiClient } from '@/stores/api/apiClient';
import { postTasksKeys } from './keys';

export function useUpdatePostTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: Partial<AgencyTaskSchema> & { id: string; postId: string }) => {
      const { id, ...body } = params;
      return apiClient.patch<ApiResponse<AgencyTaskSchema>>(`/v1/agency_tasks/${id}`, body);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: postsKeys.item(variables.postId) });
      queryClient.invalidateQueries({ queryKey: postTasksKeys.all });
    },
  });
}
